module.exports = __webpack_public_path__ + "img/img_image1.0600e02f.webp";